import React from 'react'
import { Updater, Widget, any, async, fromJSX } from 'widgets-for-react'
import { departmentBreadcrumbs } from '../../../../utils/breadcrumbs'
import { slugify } from '../../../../utils/utils'
import { Block, BlocksState } from '../../blocks/blocksState'
import { blocksWidget } from '../../blocks/blocksWidget'
import { cmsPageStateUpdaters, DepartmentPage, Page } from '../../cmsPageState'
import { DepartmentPageHeader } from './departmentPageLayout'

type AnchorLink = {
  title: string
  index: number
}

const excludedBlockKinds: Block["kind"][] = [
  'phoneNumbersBlock',
  'quoteBlock',
  'relatedContentBlock',
  'locationBlock',
  'bmiBlock'
]

const hasTitle = (b: Block): b is (typeof b & { title: string}) => !excludedBlockKinds.includes(b.kind)

const extractAnchorLinks = (whitelistedItems: string[], blocks: BlocksState): AnchorLink[] => 
  blocks.reduce((acc, b) => {
    if (!hasTitle(b)) return acc 
    if (!whitelistedItems.includes(b.title)) return acc
    return [...acc, {
      title: b.title,
      index: b.index
    }]
  }, [] as AnchorLink[])

export const departmentPageWidget =
  (acceptVideoCookie: () => void, navigationItems: string[]) =>
  (page: DepartmentPage): Widget<Updater<Page>> =>
    any([
      async<boolean>(page.hasWaitingTimesState).map(cmsPageStateUpdaters.hasWaitingTimesPageStateUpdater),
      fromJSX((setState) => (
        <DepartmentPageHeader
          toggleMenu={() => setState(cmsPageStateUpdaters.menuOpenedUpdater)}
          menuOpened={page.menuOpened}
          title={page.title}
          intro={page.intro}
          image={page.image}
          link={page.link}
          contactItems={page.department.contactItems}
          waitingTimesUrl={
            page.department && page.hasWaitingTimesState.kind === 'loaded' && page.hasWaitingTimesState.value
              ? `/wachttijden?department=${page.department.title}`
              : undefined
          }
          appointmentUrl={page.department?.appointmentUrl}
          blocks={extractAnchorLinks(navigationItems, page.blocks)}
          centrum={
            page.department?.centrum
              ? {
                  title: page.department.centrum.title,
                  url: `/afdelingen-en-centra/${slugify(page.department.centrum.title)}`,
                }
              : undefined
          }
          breadcrumbs={departmentBreadcrumbs(page)}
        />
      )),
      blocksWidget(acceptVideoCookie, {
          department: page.department 
            ? { title: page.department.title, id: page.department.id } 
            : undefined
        }
      )(page.blocks).map((updater) => cmsPageStateUpdaters.blocksUpdater(updater)),
    ])
